import { React, useEffect } from "react";
import { Table, Container, CardImg, Image } from "react-bootstrap";
import "./faq.scss";
import {
  about,
  Req,
  table,
  pack,
  allSocialProfiles,
  note,
  question,
  ques,
  twitter,
  ShortenUrl,
  video,
  policy,
  policy1,
  adManager,
  plans,
  support,
  publish,
  table1,
  table2,
  Gold30,
  Silver365,
  Gold365,
  TrialSilver,
  TrialGold,
  Paymentfailure,
  Role,
  BackOffice,
  AgencyManager,
  BrandManager,
  Analytics,
  Marketing,
  Agent,
  SocialNetworking,
  imgg,
} from "../../../../asset/json/faq.js";
import { Link, NavLink } from "react-router-dom";
import { socialIcon } from "../../../../asset/json/CardDetail";
import check from "../../../../asset/image/check-o.svg";
import close from "../../../../asset/image/close-o.svg";
import {
  SilverButton,
  GoldButton,
  PlatinumButton,
} from "../../../common/Buttons";
import { Helmet } from "react-helmet";
import { Configuration, OpenAIApi } from "openai";
import { useState } from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import DirectionsIcon from "@material-ui/icons/Directions";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "auto",
  },
  searchResult: {
    padding: "12px 10px",
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));
const Faq = () => {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth",
    });
  }, []);

  const configuration = new Configuration({
    apiKey: process.env.REACT_APP_Open,
  });
  const openai = new OpenAIApi(configuration);
  const [option, setOption] = useState({});
  const [result, setResult] = useState("");
  const [input, setInput] = useState("");
  // console.log(import.meta.env.VITE_Open_AI_Key);
  const doStuff = async () => {
    let object = {
      model: "text-davinci-002",
      prompt: input,
      temperature: 0,
      max_tokens: 100,
      top_p: 1,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    };

    const response = await openai.createCompletion(object);
    console.log("===============response=====================");
    console.log(response);
    console.log("================response====================");

    setResult(response.data.choices[0].text);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && input != "") {
      doStuff();
    }
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Faqs" />
        <meta
          name="description"
          content="Check out CloudSocial FAQ to learn about CloudSocial, its features, pricing, integrations and how to schedule a post to manage multiple social media handles."
        />
        <title>Frequently Asked Questions - CloudSocial FAQ</title>
        <link rel="canonical" href="https://cloudsocial.io/faqs" />
      </Helmet>
      <div className="mainContainer">
        {/* <div class="sidenav">
        <a href="#about">About</a>
        <a href="#price">Price</a>
        <a href="#Step">Step</a>
      </div> */}
        <Container className="main">
          <div>
            <div className="faqHeader">
              <h1 className="faqHeader mt-4">FAQ</h1>
              <h5 className="faqHeader">
                Curated FAQ’S are listed here. Try the help widget for
                comprehensive list of
              </h5>
              <h5 className="faqHeader">FAQ’S in the Knowledge Bank</h5>
            </div>
            <br />
            <div>
              {/* <div>
                <textarea
                  className="text-area"
                  cols={55}
                  rows={10}
                  onChange={(e) =>
                    setInput(e.target.value + "Related to cloudsocial.io tool")
                  }
                ></textarea>
                <button className="action-btn" onClick={doStuff}>
                  Search your doubt
                </button>

                <h3 className="result-text">
                  {result.length > 0 ? result : ""}
                </h3>
              </div> */}
              {/* <TextField
                id="outlined-full-width"
                label="Search"
                style={{ margin: 8, borderRadius: 5 }}
                placeholder="Placeholder"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              /> */}
            </div>
            <div>
              <Paper className={classes.root} onC>
                <IconButton
                  className={classes.iconButton}
                  aria-label="search"
                  onClick={doStuff}
                >
                  <SearchIcon />
                </IconButton>
                <InputBase
                  className={classes.input}
                  placeholder="Search FAQ's"
                  // inputProps={{ "aria-label": "search google maps" }}
                  onChange={(e) =>
                    setInput(e.target.value + "Related to cloudsocial.io tool")
                  }
                  onKeyDown={handleKeyDown}
                />
              </Paper>
              {result.length > 0 ? (
                <Paper className={classes.searchResult}>
                  <h6 className="faqAnswer">
                    {result.length > 0 ? result : ""}
                  </h6>
                </Paper>
              ) : (
                ""
              )}
              {/* <Paper className={classes.searchResult}>
                <h6 className="faqAnswer">{result.length > 0 ? result : ""}</h6>
              </Paper>
              <br /> */}
            </div>
            <br />
            <h4 id="about" className="faqQuestion">
              What is CloudSocial?
            </h4>
            <div className="faqAnswer mb-2">
              CloudSocial is a cloud-based platform that allows you to manage
              your social media platforms seamlessly and efficiently. You can
              use CloudSocial to post content, schedule posts, and monitor your
              feeds from a unified dashboard. In addition, it also has email as
              a social channel for a truly 360˚experience.
            </div>
            <div className="faqAnswer mb-2">
              It is a great tool for businesses that want to grow their social
              media presence. It helps them keep track of their follower base,
              as well as their engagement rates.
            </div>
            <br />
            <h4 id="about" className="faqQuestion">
              Is CloudSocial free to use?
            </h4>
            <div className="faqAnswer mb-2">
              CloudSocial is a subscription-based platform and it offers a
              7-days free trial without entering any Credit Card details. We
              offer customers the ability to manage all of their social media
              channels from one place. The features available during the trial
              will vary depending on the plan you chose. You can start your free
              trial right now!
            </div>
            <br />
            <h4 id="about" className="faqQuestion">
              Do you need a credit card for the free trial?
            </h4>
            <div className="faqAnswer mb-2">
              To start your free trial, you do not need to enter your card
              information.
            </div>
            <br />
            <h4 id="about" className="faqQuestion">
              How do I request a demo of CloudSocial?
            </h4>
            <div className="faqAnswer mb-2">
              You can click on the given link and schedule your demo at your
              convenient time.
            </div>
            <div className="faqAnswer">
              <a
                href="https://calendly.com/cloudsocial-support/csdemo"
                target="_blank"
                className=" faqUrl"
              >
                https://calendly.com/cloudsocial-support/csdemo
              </a>
            </div>
            <br />
            <h4 id="about" className="faqQuestion">
              What are all the subscription plans that CloudSocial offers?
            </h4>
            <Table
              className="tableDetail"
              striped
              bordered
              hover
              variant="dark"
              id="price"
              responsive
            >
              <thead>
                <tr className="faqTable">
                  <th className="faqQuestion" style={{ color: "white" }}>
                    #
                  </th>
                  <th className="faqQuestion" style={{ color: "white" }}>
                    <Link to="/pricing">Silver</Link>
                  </th>
                  <th className="faqQuestion" style={{ color: "white" }}>
                    <Link to="/pricing">Gold</Link>
                  </th>
                  <th className="faqQuestion" style={{ color: "white" }}>
                    <Link to="/pricing">Platinum</Link>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="faqTable">
                  <td>No. of Brands</td>
                  <td>1</td>
                  <td>3</td>
                  <td>7</td>
                </tr>
                <tr className="faqTable">
                  <td>No. of Roles</td>
                  <td>2</td>
                  <td>6</td>
                  <td>7</td>
                </tr>
                <tr className="faqTable">
                  <td>No. of Users</td>
                  <td>3</td>
                  <td>15</td>
                  <td>50</td>
                </tr>
                <tr className="faqTable">
                  <td>No. of Advance Listen Mentions</td>
                  <td>-</td>
                  <td>2000*</td>
                  <td>10,000*</td>
                </tr>
              </tbody>
            </Table>
            <br />
            <h4 id="about" className="faqQuestion mb-3">
              What are CloudSocial's features?
            </h4>
            <div className="faqAnswer mb-3">
              <b>1. Dashboard : </b>The dashboard will provide you with an
              overall view of your brand&#39;s activity across key parameters.
            </div>
            <div className="faqAnswer mb-3">
              <b>2. Calendar : </b>This feature allows you to keep track of all
              scheduled and published posts easily.
            </div>
            <div className="faqAnswer mb-3">
              <b>3. Omnibox : </b>It will enables you to respond to any incoming
              mentions (comments, messages, tweets and emails) across the
              different social media platforms. The workflows will make it
              easier for the team to respond quickly.
            </div>
            <div className="faqAnswer mb-3">
              <b>4. Listen : </b>It helps you stay on top of social media trends
              and ongoing events. Using Listening, you can monitor all of your
              social networks, your competitors and spot prospects from afar
              using unique keywords and additional filter options to customize
              your search.
            </div>
            <div className="faqAnswer mb-3">
              <b>5. Sentiment Analysis : </b>The Sentiment Analysis will assist
              you in understanding what your customers are saying about your
              brand so that you can respond appropriately.
            </div>
            <div className="faqAnswer mb-3">
              <b>6. Analytics : </b>Analytics is a tool that can be used to get
              insights into your strategy and help you plan for the future. It
              helps you make the right decisions based on data and not on
              guesses. CloudSocial also has a Net Promoter Score, or NPS, which
              measures customer satisfaction. NPS works as a loyalty metric that
              lets you improve customer loyalty over time.
            </div>
            <div className="faqAnswer mb-3">
              <b>7. Support : </b>We are available to assist you via live chat,
              email, and online calls 24 hours a day, 7 days a week.
            </div>
            <br />
            <div className="faqQuestion">What are social channels?</div>
            <div className="faqAnswer mb-1">
              By social channels, we mean any of the social media channels that
              CloudSocial can currently manage. It could be any of the following
              options :
            </div>
            <ul>
              <li className="faqAnswer mb-1">Facebook Business Page</li>
              <li className="faqAnswer mb-1">Facebook Ad Manager</li>
              <li className="faqAnswer mb-1">Facebook Messenger</li>
              <li className="faqAnswer mb-1">Facebook Groups</li>
              <li className="faqAnswer mb-1">Facebook Profile</li>
              <li className="faqAnswer mb-1">Instagram Business Page</li>
              <li className="faqAnswer mb-1">Instagram Ad Manager</li>
              <li className="faqAnswer mb-1">Instagram Messenger</li>
              <li className="faqAnswer mb-1">Twitter Profile</li>
              <li className="faqAnswer mb-1">Twitter DM</li>
              <li className="faqAnswer mb-1">LinkedIn Profile</li>
              <li className="faqAnswer mb-1">LinkedIn Business Page</li>
              <li className="faqAnswer mb-1">Pinterest</li>
              <li className="faqAnswer mb-1">YouTube Channel Page</li>
              <li className="faqAnswer mb-1">Email</li>
              <li className="faqAnswer mb-1">Medium</li>
              <li className="faqAnswer mb-1">Tik Tok</li>
              <li className="faqAnswer mb-1">Google My Business</li>
              <li className="faqAnswer mb-1">Google Analytics</li>
              <li className="faqAnswer mb-1">Google Business Messaging</li>
            </ul>
            <br />
            <div className="faqQuestion">What are mentions?</div>
            <div className="faqAnswer">
              In CloudSocial, all incoming comments, direct messages, tweets,
              and emails are classified as mentions.
            </div>
            <br />
            <div className="faqQuestion">What is Omnibox?</div>
            <div className="faqAnswer">
              Omnibox is where you find and respond to all of your incoming
              mentions. No more juggling multiple tools, especially in an age
              when consumers believe in reaching out to brands in a variety of
              ways. However, they expect quick resolution regardless of which
              channel they use.
            </div>
            <br />
            <div className="faqQuestion">
              What all social networks does CloudSocial support?
            </div>
            <ul>
              <li className="faqAnswer mb-1">Facebook</li>
              <li className="faqAnswer mb-1">YouTube</li>
              <li className="faqAnswer mb-1">Instagram</li>
              <li className="faqAnswer mb-1">LinkedIn</li>
              <li className="faqAnswer mb-1">Pinterest</li>
              <li className="faqAnswer mb-1">Twitter</li>
              <li className="faqAnswer mb-1">Google My Business</li>
              <li className="faqAnswer mb-1">Google Analytics</li>
              <li className="faqAnswer mb-1">Medium</li>
              <li className="faqAnswer mb-1">Tik Tok</li>
            </ul>
            <br />
            <div className="faqQuestion">
              When I need support from CloudSocial, how do I get in touch with
              CloudSocial Customer Support?
            </div>
            <div className="faqAnswer">
              We take your support very seriously. If you need assistance
              configuring or using CloudSocial, we are here to help. You can
              contact our support team via the &nbsp;
              <a
                href="https://app.cloudsocial.io/accounts/login"
                target="_blank"
                className="faqUrl"
              >
                Support Tab
              </a>
              &nbsp; within CloudSocial. You can contact us via ticket, chat, or
              email. We are available 24 hours a day, 7 days a week, and 365
              days a year. Each of our packs is subject to this policy.
            </div>
          </div>
          <hr></hr>
        </Container>
      </div>
    </div>
  );
};

export default Faq;
